var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancel"},[_vm._v("\n  已失效\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }